// @moods/ui copy for the cards components. tr and en must have identical keys.
// Turkish part; cards.en.ts must have the same keys.
const dict: Record<string, string> = {
  'cards.community.online': '{count} çevrimiçi',
  'cards.community.members': '{count} üye',
  'cards.community.join': 'Katıl',
  'cards.community.joined': 'Katıldın',
  'cards.community.unread': 'Okunmamış mesajlar var',
  'cards.community.mentions.one': '{count} bahsedilme',
  'cards.community.mentions.other': '{count} bahsedilme',

  'cards.event.type.stage': 'Sahne',
  'cards.event.type.voice': 'Ses',
  'cards.event.type.video': 'Video',
  'cards.event.type.external': 'Dış etkinlik',
  'cards.event.live': 'ŞİMDİ',
  'cards.event.interest': 'İlgileniyorum',
  'cards.event.interestShort': 'İlgilen',
  'cards.event.interested': 'İlgileniyorsun',
  'cards.event.interestedCount': '{count} ilgileniyor',
  'cards.event.today': 'Bugün {time}',
  'cards.event.tomorrow': 'Yarın {time}',

  'cards.conv.unread.one': '{count} okunmamış mesaj',
  'cards.conv.unread.other': '{count} okunmamış mesaj',

  'cards.now.live': 'CANLI',
  'cards.now.cta.voice': 'Katıl',
  'cards.now.cta.stream': 'İzle',
  'cards.now.cta.playing': 'Mesaj',
  'cards.now.cta.event': 'Katıl',
  'cards.now.cta.listening': 'Mesaj',

  'empty.no-messages.title': 'Henüz mesaj yok',
  'empty.no-messages.description': 'Sohbeti başlatan ilk kişi sen olabilirsin.',
  'empty.no-friends.title': 'Henüz arkadaşın yok',
  'empty.no-friends.description':
    'Kullanıcı adıyla arkadaş ekleyebilir ya da topluluklarda yeni insanlarla tanışabilirsin.',
  'empty.no-communities.title': 'Henüz bir topluluğa katılmadın',
  'empty.no-communities.description':
    'Keşfet’te ilgi alanlarına uygun toplulukları bul ya da kendi topluluğunu oluştur.',
  'empty.no-notifications.title': 'Her şey sakin',
  'empty.no-notifications.description': 'Yeni bir bahsedilme ya da davet olduğunda burada göreceksin.',
  'empty.no-search-results.title': 'Sonuç bulunamadı',
  'empty.no-search-results.description': 'Farklı bir kelime dene ya da filtreleri temizle.',
  'empty.no-events.title': 'Yaklaşan etkinlik yok',
  'empty.no-events.description': 'Toplulukların bir etkinlik planladığında burada görünecek.',
  'empty.no-online-members.title': 'Şu an kimse çevrimiçi değil',
  'empty.no-online-members.description': 'Üyeler çevrimiçi olduğunda burada görünecek.',
  'empty.no-threads.title': 'Henüz akış yok',
  'empty.no-threads.description': 'Bir mesajdan akış başlatarak konuşmayı ayrı tutabilirsin.',
  'empty.no-saved-messages.title': 'Kaydedilmiş mesaj yok',
  'empty.no-saved-messages.description':
    'Kaydettiğin mesajlar daha sonra kolayca bulman için burada durur.',
  'empty.no-pins.title': 'Sabitlenmiş mesaj yok',
  'empty.no-pins.description': 'Önemli mesajları sabitleyerek herkesin kolayca bulmasını sağlayabilirsin.',
  'empty.not-found.title': 'Bu sayfa bulunamadı',
  'empty.not-found.description': 'Bağlantı eskimiş ya da sayfa taşınmış olabilir.',
  'empty.server-error.title': 'Bir şeyler ters gitti',
  'empty.server-error.description': 'Sorun bizde. Birkaç saniye sonra tekrar dene.',
  'empty.no-permission.title': 'Bu alana erişimin yok',
  'empty.no-permission.description': 'Burayı görmek için gereken izinlere sahip değilsin.',
  'empty.offline.title': 'Bağlantı yok',
  'empty.offline.description':
    'İnternet bağlantını kontrol et. Yeniden bağlandığında kaldığın yerden devam edersin.',
};

export default dict;
